import type { Scope } from './types'

const KEY = 'crm:overzicht:scope'

/** The remembered choice Mijn | Team; null on a first visit or when storage is unavailable. */
export function readScope(): Scope | null {
  try {
    const value = window.localStorage.getItem(KEY)
    return value === 'mine' || value === 'team' ? value : null
  } catch {
    return null
  }
}

export function writeScope(scope: Scope): void {
  try {
    window.localStorage.setItem(KEY, scope)
  } catch {
    // Private window or blocked storage: the choice just is not remembered.
  }
}
